




























import { Component, Vue } from 'vue-property-decorator'
import { vxm } from '@/store/'
import thirdLevel from './thirdLevel.vue'

@Component({
  props: ['items'],
  components: {
    thirdLevel
  }
})
export default class MenuFirstLvl extends Vue {
  get activeMenuId() {
    return vxm.menu.activeMenuId
  }
  get activeItemId() {
    return (
      this.activeMenuId[0] +
      '.' +
      this.activeMenuId[1] +
      '.' +
      this.activeMenuId[2]
    )
  }

  setActiveMenu(id: string) {
    vxm.menu.setActiveMenu(id)
  }
}
